import type { IPageSettings } from "../../../src/taskpane/interfaces/IPageSettings";
import type { ISharepointListLocation } from "../../Services/LocationService";

/**
 * The directory-shaped stand-in the per-library hook checks run against (HooksService
 * isValidHook compares its siteDisplayName and DocumentLibrary). A client-group library carries
 * its own site's name, so its rows are checked against THAT site; the site's own libraries use
 * the current site's name.
 */
export const buildHookValidationDirectory = (location: ISharepointListLocation | undefined, siteDisplayName: string | undefined): IPageSettings => ({
    siteDisplayName: location?.siteDisplayName ?? siteDisplayName,
    DocumentLibrary: location?.displayName,
} as IPageSettings);
